import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ProfileModel } from 'src/app/models/profile.model';
import { MenuItem } from 'src/app/models/rich-data.model';

@Component({
  selector: 'app-order-alert',
  templateUrl: './order-alert.component.html',
  styleUrls: ['./order-alert.component.css']
})
export class OrderAlertComponent implements OnInit {
  @Input() orderDate: string;
  @Input() orderTime: string;
  @Input() menuItem: MenuItem;
  @Input() profile: ProfileModel;

  constructor(
    private mdlCtrl: ModalController
  ) { }

  ngOnInit() {
  }

  async close() {
    await this.mdlCtrl.dismiss();
  }

}
